<section id="content">

	<div class="spinner-container">
		<div class="spinner">
			<div class="sk-folding-cube">
				<div class="sk-cube1 sk-cube"></div>
				<div class="sk-cube2 sk-cube"></div>
				<div class="sk-cube4 sk-cube"></div>
				<div class="sk-cube3 sk-cube"></div>
			</div>
		</div>
	</div>

	<!-- <div class="spinner-container">

			<div class="spinner">
				<div class="sk-folding-cube">
					<div class="sk-cube1 sk-cube"></div>
					<div class="sk-cube2 sk-cube"></div>
					<div class="sk-cube4 sk-cube"></div>
					<div class="sk-cube3 sk-cube"></div>
				</div>
			</div>

			<script>
				$("body").css("overflow-y", "hidden");
				setTimeout(() => {
					$(".spinner-container").fadeOut();
					$("body").css("overflow-y", "auto");
				}, 5000);
			</script>
		</div> -->
	<div class="form-group">
		<div class="card">
			<div class="card-title">
				<h2>User Management</h2>
			</div>
			<p-messages [escape]="true" [value]="msgs"></p-messages>
			<div class="cont">
				<div class="group" sec:authorize="hasAuthority('user_management')">
					<div class="collapse-title"
						(click)="ele.class = ele.class == 'hideChildren' ? '' :  'hideChildren'">User Management
						<i class="collapse-icon fa"
							[ngClass]=" ele.class !== 'hideChildren' ? 'fa-minus' : 'fa-plus'"></i>
					</div>
					<div class="collapse in show" id="userManagementGroup"
						[ngClass]="{ hideChildren : ele.class == 'hideChildren' }" #ele>
						<div class="group-cont">
							<div class="table-respnsive">
								<p-table #dt class="table" styleClass="ui-table-customers"
									tableStyleClass="table table-respnsive" [value]="usersList"
									totalRecords="{{usersList.length}}" [rows]="10" [showCurrentPageReport]="true"
									[rowsPerPageOptions]="[10,25,50]" [paginator]="true"
									currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

									<ng-template pTemplate="header">
										<tr>
											<th pSortableColumn="empId" width="12%">Emp Id<p-sortIcon
													field="empId"></p-sortIcon></th>
											<th pSortableColumn="firstName" width="12%">First Name<p-sortIcon
													field="firstName"></p-sortIcon></th>
											<th pSortableColumn="lastName" width="12%">Last Name<p-sortIcon
													field="lastName"></p-sortIcon></th>
											<th pSortableColumn="email" width="12%">Email<p-sortIcon
													field="email"></p-sortIcon></th>
											<th pSortableColumn="manager" width="12%">Manager<p-sortIcon
													field="sector"></p-sortIcon></th>
											<th pSortableColumn="quota" width="12%">Quota<p-sortIcon
													field="quota"></p-sortIcon></th>
											<th pSortableColumn="role.userRole" width="9%">Role<p-sortIcon
													field="role.userRole"></p-sortIcon></th>
											<th pSortableColumn="appliancesRole.roleName" width="9%">Appliance Role<p-sortIcon
														field="appliancesRole.roleName"></p-sortIcon></th>
											<!-- <th pSortableColumn="" width="10%">Brand Lead Items<p-sortIcon
													field=""></p-sortIcon></th> -->
											<th colspan="3" width="5%" class="text-center"><span class="add"
													style="cursor: pointer;"><i class="la la-plus"
														(click)="openAddUserDialog($event)"></i></span></th>
											<!-- <th></th>
											<th></th> -->


										</tr>
										<tr>
											<th><input pInputText class="textfilter" type="text"
													(input)="dt.filter($event.target.value, 'empId', 'contains')"
													placeholder="Search by Employee ID"></th>
											<th><input pInputText class="textfilter" type="text"
													(input)="dt.filter($event.target.value, 'firstName', 'contains')"
													placeholder="Search by First Name"></th>
											<th><input pInputText class="textfilter" type="text"
													(input)="dt.filter($event.target.value, 'lastName', 'contains')"
													placeholder="Search by Last Name"></th>
											<th><input pInputText class="textfilter" type="text"
													(input)="dt.filter($event.target.value, 'email', 'contains')"
													placeholder="Search by Email"></th>
											<th><input pInputText class="textfilter" type="text"
													(input)="dt.filter($event.target.value, 'manager', 'contains')"
													placeholder="Search by Manager Name"></th>
											<th><input pInputText class="textfilter" type="text"
													(input)="dt.filter($event.target.value, 'quota', 'contains')"
													placeholder="Search by Quota"></th>
											<th>
												<!--<input pInputText class="textfilter" type="text" (input)="dt.filter($event.target.value, 'role.userRole', 'contains')" placeholder="Search by Role"> -->
												<p-dropdown class="dropdownfilter" [options]="rolesDropdown"
													defaultLabel=" " placeholder="Search by Role" [showClear]="true"
													optionLabel="label" optionValue="value"
													(onChange)="dt.filter($event.value, 'role.userRole', 'equals')"></p-dropdown>
											</th>
											<th>
												<!--<input pInputText class="textfilter" type="text" (input)="dt.filter($event.target.value, 'role.userRole', 'contains')" placeholder="Search by Role"> -->
												<p-dropdown class="dropdownfilter" [options]="applianceRolesDropdown"
												 placeholder="Search by Appliance Role" [showClear]="true"
												optionLabel="label" optionValue="value"
												(onChange)="logValue($event); dt.filter($event.value, 'appliancesRole.roleId', 'equals')"></p-dropdown>

											</th>
											<th></th>
											<th></th>
											<th></th>

										</tr>

									</ng-template>
									<ng-template pTemplate="body" let-userrow let-expanded="expanded">
										<tr (dblclick)="editUserData(userrow.userId)">
											<td class="year">{{userrow.empId}}</td>
											<td>{{userrow.firstName}}</td>
											<td>{{userrow.lastName}}</td>
											<td>{{userrow.email}}</td>
											<td>{{userrow.manager}}</td>
											<td>{{userrow.quota}}</td>
											<td>{{userrow.role.userRole}}</td>
											<td>{{userrow.appliancesRole.roleName}}</td>
											<td></td>

											<td>
												<ul>
													<li class="add" *ngIf="isBrandLead(userrow.role.roleId)">
														<i class="la la-tags" style="cursor: pointer;"
															(click)="openBrandLeadDialog(userrow.userId)"></i>
													</li>
												</ul>
											</td>

											<td>
												<ul>
													<li class="add">
														<i class="la la-sliders" style="cursor: pointer;"
															(click)="openPermissionDialog($event, userrow.userId)"></i>
													</li>
												</ul>
											</td>

											<td>
												<ul>
													<li class="add">
														<i class="la la-tag" style="cursor: pointer;"
															(click)="openTagsDialog($event, userrow.userId)"></i>
													</li>
												</ul>
											</td>

											<td>
												<ul>
													<li>
														<div class="delete text-red"><i style="cursor: pointer;"
																class="la la-trash"
																(click)="onDeleteUser(userrow.userId)"></i>
														</div>
													</li>

												</ul>
											</td>
										</tr>
									</ng-template>


								</p-table>

							</div>
						</div>
						<!-- /.group-cont -->
					</div>
				</div>
			</div>
		</div>

	</div>
</section>

<form name="myForm" #f="ngForm" novalidate (ngSubmit)="onSubmit($event)">

	<p-dialog [header]="addEditUserHeader" [visible]="displayDialog" [modal]="true" width="500" height="600"
		responsive="true" [resizable]="false" [closable]="false">


		<table class="table editable" id="user-table">
			<thead>

				<tr>
					<th class="empIduser">Emp Id</th>
					<th class="firstNameuser">First Name</th>
					<th class="lastNameuser">Last Name</th>
					<th class="emailuser">Email</th>
					<th class="Manageruser">Manager</th>
					<th class="quotauser">Quota</th>
					<th class="roleuser">Role</th>
					<th class="appliancesRole"> Appliance Role </th>
					<th class="BrandLeadItemsuser"> </th>
				</tr>
			</thead>
			<tr height="110px">
				<td style="vertical-align: top;">
					<!--<input type="text" id="empId" required formControlName="empId" [(ngModel)]="userDTO.empId" class="input">-->
					<input type="text" name="empId" class="form-control" [(ngModel)]="userDTO.empId" #empId="ngModel"
						class="input" required>
					<div *ngIf="f.submitted && empId.invalid" class="alert alert-danger">
						<div *ngIf="empId.errors.required">empid is required</div>
					</div>
					<!--<div *ngIf="myGroup.controls['empId'].invalid && (myGroup.controls['empId'].dirty || myGroup.controls['empId'].touched)"
										class="alert alert-danger">
										<div *ngIf="empId.errors.required">
										  Emp Id is required.
										</div>
						</div>-->
				</td>
				<td style="vertical-align: top;">
					<input type="text" name="firstName" id="firstName" #firstName="ngModel" required
						[(ngModel)]="userDTO.firstName" class="input">
					<div *ngIf="f.submitted && firstName.invalid" class="alert alert-danger">
						<div *ngIf="firstName.errors.required">First Name is required</div>
					</div>
					<!--div *ngIf="myGroup.controls['firstName'].invalid && (myGroup.controls['firstName'].dirty || myGroup.controls['firstName'].touched)"
										class="alert alert-danger">
										<div *ngIf="myGroup.controls['firstName'].errors.required">
										  First Name is required.
										</div>
						</div>-->
				</td>
				<td style="vertical-align: top;">
					<input type="text" name="lastName" id="lastName" #lastName="ngModel" required
						[(ngModel)]="userDTO.lastName" class="input">
					<div *ngIf="f.submitted && lastName.invalid" class="alert alert-danger">
						<div *ngIf="lastName.errors.required">Last Name is required</div>
					</div>
					<!--<input type="text" id="lastName" required formControlName="lastName" [(ngModel)]="userDTO.lastName" class="input">
						<div *ngIf="myGroup.controls['lastName'].invalid && (myGroup.controls['lastName'].dirty || myGroup.controls['lastName'].touched)"
										class="alert alert-danger">
										<div *ngIf="myGroup.controls['lastName'].errors.required">
											Last Name is required.
										</div>
						</div>-->
				</td>
				<td style="vertical-align: top;">
					<input type="text" name="password" id="password" [(ngModel)]="userDTO.password"
						style="display: none;" class="input hidden">
					<input type="text" name="email" id="email" #email="ngModel" required [(ngModel)]="userDTO.email"
						class="input">
					<div *ngIf="f.submitted && email.invalid" class="alert alert-danger">
						<div *ngIf="email.errors.required">Email Name is required</div>
					</div>
					<!--<input type="text" id="email"  required formControlName="email"  [(ngModel)]="userDTO.email"  class="input">
						<div *ngIf="myGroup.controls['email'].invalid && (myGroup.controls['email'].dirty || myGroup.controls['email'].touched)"
										class="alert alert-danger">
										<div *ngIf="myGroup.controls['email'].errors.required">
											Email is required.
										</div>
										<div *ngIf="myGroup.controls['email'].errors.email">
											Invalid Email.
										  </div>
						</div>
					-->
				</td>
				<td style="vertical-align: top;">
					<select class="input" id="managerId" name="managerId" required #managerId="ngModel"
						[(ngModel)]="userDTO.managerId">
						<option id="-1" selected default="yes" [ngValue]="null" value="null">Select</option>
						<option *ngFor="let user of managersList; let i = index" [value]="user?.userId">
							{{user?.firstName}} {{user?.lastName}}
						</option>
					</select>
					<div *ngIf="f.submitted && managerId.invalid" class="alert alert-danger">
						<div *ngIf="managerId.errors.required">Manager is required</div>
					</div>
					<!--<select class="input" id="managerId" required formControlName="manager"  [(ngModel)]="userDTO.managerId"  >
							<option id="-1" selected default="yes" [ngValue]="null" value="null">Select</option>
							<option *ngFor="let user of managersList; let i = index" [value]="user?.userId">
								{{user?.firstName}} {{user?.lastName}}
							</option>
						</select>
						<div *ngIf="myGroup.controls['manager'].invalid && (myGroup.controls['manager'].dirty || myGroup.controls['manager'].touched)"
										class="alert alert-danger">
										<div *ngIf="myGroup.controls['manager'].errors.required">
											Manager is required.
										</div>
						</div> -->
				</td>
				<td style="vertical-align: top;">
					<input type="text" id="quota" required="false" name="quota" [(ngModel)]="userDTO.quota"
						class="input">
				</td>
				<td style="vertical-align: top;">
					<select class="input" id="role" required #role="ngModel" name="role"
						[(ngModel)]="userDTO.role.roleId">
						<option id="-1" selected default="yes" [ngValue]="null" value="null">Select</option>
						<option *ngFor="let role of rolesList; let i = index" [value]="role?.roleId">
							{{role?.userRole}}
						</option>
					</select>
					<div *ngIf="f.submitted && role.invalid" class="alert alert-danger">
						<div *ngIf="role.errors.required">Role is required</div>
					</div>

					<!--<select class="input" required formControlName="role" [(ngModel)]="userDTO.role.roleId" id="role">
							<option id="-1" selected default="yes" [ngValue]="null" value="null">Select</option>
							<option *ngFor="let role of rolesList; let i = index" [value]="role?.roleId">
								{{role?.userRole}}
							</option>
						</select>
						<div *ngIf="myGroup.controls['role'].invalid && (myGroup.controls['role'].dirty || myGroup.controls['role'].touched)"
										class="alert alert-danger">
										<div *ngIf="myGroup.controls['role'].errors.required">
											Role is required.
										</div>
						</div>-->
				</td>


				<td style="vertical-align: top;">
					<select class="input" id="appliancesRole" required #applanceRole="ngModel" name="applianceRole"
					[(ngModel)]="userDTO.appliancesRole.roleId">
					<option id="-1" selected default="yes" [ngValue]="null" value="null">Select</option>
					<option *ngFor="let applanceRole of applianceRoleList; let i = index" [value]="applanceRole?.roleId">
						{{applanceRole?.roleName}}
					</option>
				</select>
				<div *ngIf="f.submitted && applanceRole.invalid" class="alert alert-danger">
					<div *ngIf="applanceRole.errors.required">Appliance Role is required</div>
				</div>

				</td>

				<td class="options" style="vertical-align: top;">
					<ul class="actions">
						<li class="confirm">
							<!--<i class="la la-check commit" id="x1" onclick="myForm.submit();"></i>-->
							<button id="finish" style="background-color: #36D9B0;border: 0;color: white;"><i
									class="la la-check commit" id="x1"></i></button>
						</li>
						<li class="cancel">
							<i class="la la-close" (click)="closeDialog($event)"></i>
						</li>
					</ul>
				</td>
			</tr>
		</table>
	</p-dialog>
</form>

<!-- User Tags Dialog -->
<p-dialog header="{{currentUsername}} - Tags" [(visible)]="displayTagsDialog" [modal]="true" [closable]="false"
    [resizable]="false" [style]="{width: '50%'}" styleClass="tags-dialog">
    <p-messages class="fixed-messages" [escape]="true" [value]="tagMsgs"></p-messages>

    <div class="dialog-content tags-dialog-content">
        <h4>Add Tags</h4>
        <div class="add-tags">
            <div class="tag-type-selector mb-2">
                <label for="tagType">Select Tag Type:</label>
                <p-dropdown [options]="tagTypes" [(ngModel)]="selectedTagType"
                    (onChange)="onTagTypeChange($event)" styleClass="w-100 mb-2"
                    placeholder="Select tag type"></p-dropdown>
            </div>

            <p-multiSelect [options]="availableTags" [(ngModel)]="selectedTags"
                optionLabel="tag" optionValue="id"
                [style]="{width:'100%'}" [panelStyle]="{width:'100%'}"
                placeholder="Select tags to add"></p-multiSelect>
            <div class="text-right">
                <button type="button" class="btn btn-primary mt-3" (click)="addTagToUser()"
                    [disabled]="!selectedTags || selectedTags.length === 0">
                    Add Selected Tags
                </button>
            </div>
        </div>

        <h4>Current Tags</h4>
        <div class="user-tags">
            <div *ngFor="let tag of userTags" class="tag-item">
                <span class="tag-name">{{tag.tag}} <span class="tag-type">({{tag.tagType}})</span></span>
                <button type="button" class="btn btn-sm btn-danger" (click)="removeTagFromUser(tag.id)">
                    <i class="la la-times"></i>
                </button>
            </div>
            <div *ngIf="userTags.length === 0" class="no-tags">
                No tags assigned to this user
            </div>
        </div>
    </div>

    <p-footer>
        <button type="button" (click)="closeTagsDialog()" class="btn btn-primary">Close</button>
    </p-footer>
</p-dialog>

<p-dialog header="Select Brands" [(visible)]="displayBrandLeadDialog" [modal]="true" [closable]="false"
	[resizable]="false" [style]="{height: '85%', width: '27%', overflow: 'auto'}">
	<p-messages class="fixed-messages" [escape]="true" [value]="brandsMsgs"></p-messages>

	<div *ngIf="selectedUserId">
		<div *ngFor="let item of items; let i = index">
			<input type="checkbox" name="{{item?.item}}" value="{{item?.itemId}}" class="multiple_select_checkbox"
				style="width: 28%; margin: .4rem;" [checked]="selectItem(item, selectedUserId)"
				(click)="AddUpdateBrandLeadUser($event, selectedUserId, item.itemId)">
			<label style="padding-top: 10%;">{{item?.item}}</label>
		</div>
	</div>
	<p-footer>
		<!-- <button type="button" (click)="closeBrandLeadDialog()" class="brand-dialog-close-button">Close</button> -->

		<button type="button" (click)="closeBrandLeadDialog()" class="btn btn-primary">Close</button>

	</p-footer>
</p-dialog>

<form [formGroup]="myPermissionGroup" #addPermissionGroupForm id="myPermissionForm" novalidate
	(ngSubmit)="addPermission($event)">

	<p-dialog header="User Permissions" [visible]="displayPermDialog" [modal]="true" width="500" height="600"
		responsive="true" [resizable]="false" [closable]="false" closeOnEscape="true">
		<div class="form-group" [formGroup]="myPermissionGroup">
			<p-messages [escape]="true" [value]="permMsgs"></p-messages>
			<table class="table editable" id="userRule&amp;1-table" width="100%">
				<thead>
					<tr>
						<th class="canEdit">Can Edit</th>
						<th class="canCreate">Can Create</th>
						<th class="canDelete">Can Delete</th>
						<th class="canView">Can View</th>
						<th class="lob">Lob</th>
						<th class="region">Region</th>
						<th class="sector">Sector</th>
						<th class="text-center" width="10%">
							<span class="add">
								<i class="la la-plus" (click)="enableAddPermissionRow($event)"></i>
							</span>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of userPermissionList; let i = index">
						<td>
							<input type="text" [value]="item?.canEdit" class="disabled">
						</td>
						<td>
							<input type="text" [value]="item?.canCreate" class="disabled">
						</td>
						<td>
							<input type="text" [value]="item?.canDelete" class="disabled">
						</td>
						<td>
							<input type="text" [value]="item?.canView" class="disabled">
						</td>
						<td>
							<input type="text" [value]="item?.lob" class="disabled">
						</td>

						<td>
							<input type="text" [value]="item?.region?.region" class="disabled">
						</td>
						<td>
							<input type="text" [value]="item?.sector?.sector" class="disabled">
						</td>
						<td>
							<ul>
								<li class="delete text-red"><i class="la la-trash"
										(click)="deletePermission($event,item.ruleId)"></i></li>
							</ul>
						</td>
					</tr>
					<tr height="110px" [class]="addPermissionRowClass">
						<td style="vertical-align: top;">
							<select class="input" id="canEdit" required formControlName="canEdit"
								[(ngModel)]="userPermission.canEdit">
								<option id="1" value="true">true</option>
								<option id="2" value="false">false</option>
							</select>
							<div *ngIf="myPermissionGroup.controls['canEdit'].invalid && (myPermissionGroup.controls['canEdit'].dirty || myPermissionGroup.controls['canEdit'].touched)"
								class="alert alert-danger">
								<div *ngIf="myPermissionGroup.controls['canEdit'].errors.required">
									Can Edit required.
								</div>
							</div>
						</td>
						<td style="vertical-align: top;">
							<select class="input" id="canCreate" formControlName="canCreate"
								[(ngModel)]="userPermission.canCreate">
								<option id="1" value="true">true</option>
								<option id="2" value="false">false</option>
							</select>
							<div *ngIf="myPermissionGroup.controls['canCreate'].invalid && (myPermissionGroup.controls['canCreate'].dirty || myPermissionGroup.controls['canCreate'].touched)"
								class="alert alert-danger">
								<div *ngIf="myPermissionGroup.controls['canCreate'].errors.required">
									Can Create required.
								</div>
							</div>
						</td>
						<td style="vertical-align: top;">
							<select class="input" id="canDelete" formControlName="canDelete"
								[(ngModel)]="userPermission.canDelete">
								<option id="1" value="true">true</option>
								<option id="2" value="false">false</option>
							</select>
							<div *ngIf="myPermissionGroup.controls['canDelete'].invalid && (myPermissionGroup.controls['canDelete'].dirty || myPermissionGroup.controls['canDelete'].touched)"
								class="alert alert-danger">
								<div *ngIf="myPermissionGroup.controls['canDelete'].errors.required">
									Can Delete required.
								</div>
							</div>
						</td>
						<td style="vertical-align: top;">
							<select class="input" id="canView" formControlName="canView"
								[(ngModel)]="userPermission.canView">
								<option id="1" value="true">true</option>
								<option id="2" value="false">false</option>
							</select>
							<div *ngIf="myPermissionGroup.controls['canView'].invalid && (myPermissionGroup.controls['canView'].dirty || myPermissionGroup.controls['canView'].touched)"
								class="alert alert-danger">
								<div *ngIf="myPermissionGroup.controls['canView'].errors.required">
									Can View required.
								</div>
							</div>
						</td>
						<td style="vertical-align: top;">
							<select class="input" id="lob" formControlName="lob" [(ngModel)]="userPermission.lob">
								<option id="-1" default="yes" [ngValue]="null" value="null">Lob</option>
								<option value=" "> </option>
								<option value="SWG">SWG</option>
								<option value="STG">STG</option>

							</select>
							<div *ngIf="myPermissionGroup.controls['lob'].invalid && (myPermissionGroup.controls['lob'].dirty || myPermissionGroup.controls['lob'].touched)"
								class="alert alert-danger">
								<div *ngIf="myPermissionGroup.controls['lob'].errors.required">
									Please select Lob from dropdown.
								</div>
							</div>
						</td>

						<td style="vertical-align: top;">
							<select class="input" id="regionPerm" formControlName="regionPerm"
								[(ngModel)]="userPermission.region.regionId">
								<option id="-1" default="yes" [ngValue]="null" value="null">Region</option>
								<option *ngFor="let region of regionsList; let i = index" [value]="region?.regionId">
									{{region?.region}}
								</option>
							</select>
							<div *ngIf="myPermissionGroup.controls['regionPerm'].invalid && (myPermissionGroup.controls['regionPerm'].dirty || myPermissionGroup.controls['regionPerm'].touched)"
								class="alert alert-danger">
								<div *ngIf="myPermissionGroup.controls['regionPerm'].errors.required">
									Region required.
								</div>
							</div>
						</td>

						<td style="vertical-align: top;">
							<select class="input" id="sector" formControlName="sectorPerm"
								[(ngModel)]="userPermission.sector.sectorId">
								<option id="-1" default="yes" [ngValue]="null" value="null">Sector</option>
								<option *ngFor="let sector of sectorList; let i = index" [value]="sector?.sectorId">
									{{sector?.sector}}
								</option>
							</select>
							<div *ngIf="myPermissionGroup.controls['sectorPerm'].invalid && (myPermissionGroup.controls['sectorPerm'].dirty || myPermissionGroup.controls['sectorPerm'].touched)"
								class="alert alert-danger">
								<div *ngIf="myPermissionGroup.controls['sectorPerm'].errors.required">
									Sector required.
								</div>
							</div>
						</td>

						<td style="vertical-align: top;" class="options" nowrap>
							<ul class="actions">
								<li class="confirm"><button id="savePermission"
										style="background-color: #36D9B0;border: 0;color: white;line-height: 25px;"><i
											class="la la-check commit" id="xd41"></i></button>
								</li>
								<li class="cancel"><i class="la la-close" (click)="disableAddPermissionRow($event)"></i>
								</li>
							</ul>
						</td>
					</tr>
				</tbody>
			</table>
			<p-header>
				<!--<button style="background-color: #F22435;" type="button" (click)="ClosePermissionDialog()" label="Accept">Close</button>-->
				<table width="100%">
					<tr>
						<td style="text-align: right;">
							<ul class="actions">
								<li class="confirm">
									<!--<i class="la la-check commit" id="x1" onclick="myForm.submit();"></i>-->
									<button id="close"
										style="background-color: #36D9B0;border: 0;color: white;line-height: 25px;"
										(click)="ClosePermissionDialog()">Close</button>
								</li>
							</ul>
						</td>
					</tr>
				</table>
			</p-header>
		</div>
	</p-dialog>



</form>
